module.exports = __webpack_public_path__ + "img/deposit.16597600.jpg";